import React from 'react';
import {
  Grid,
  Paper,
  Box,
  Typography,
  Avatar,
  alpha,
  useTheme,
} from '@mui/material';
import { 
  MilitaryTech,
  EmojiEvents 
} from '@mui/icons-material';
import { Metrics } from '../../../../types/metrics';

interface AdditionalStatsProps {
  metrics: Metrics | null;
}

const AdditionalStats: React.FC<AdditionalStatsProps> = ({ metrics }) => {
  const theme = useTheme();
  console.log('DEBUG: metrics =', metrics); 

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Paper 
          sx={{ 
            p: 3, 
            borderRadius: 2,
            height: '100%',
            boxShadow: theme.shadows[3],
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Major Donors
            </Typography>
            <Avatar 
              sx={{ 
                bgcolor: alpha(theme.palette.warning.main, 0.1), 
                color: theme.palette.warning.main 
              }}
            >
              <MilitaryTech />
            </Avatar>
          </Box>
          <Typography variant="h4" fontWeight={700} sx={{ my: 1 }}>
            {metrics?.majorDonors?.toLocaleString() || "0"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Donors who contributed over $1,000
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Paper 
          sx={{ 
            p: 3, 
            borderRadius: 2,
            height: '100%',
            boxShadow: theme.shadows[3],
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Repeat Donors
            </Typography>
            <Avatar 
              sx={{ 
                bgcolor: alpha(theme.palette.secondary.main, 0.1), 
                color: theme.palette.secondary.main 
              }}
            >
              <EmojiEvents />
            </Avatar>
          </Box>
          <Typography variant="h4" fontWeight={700} sx={{ my: 1 }}>
            {metrics?.repeatDonors?.toLocaleString() || "0"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Donors who made multiple contributions
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AdditionalStats; 